<script lang="ts" setup>
import { type PropType } from 'vue';
import { FormElement, useFormElement } from '@common';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const { enabled } = useFormElement(props.element);
</script>

<template>
  <div>
    <div
      class="v-display-value"
      :class="{ 'text-disabled': !enabled }"
      data-testid="crop-name-value"
      v-for="(blockedBy, index) in element.value"
      :key="index">
      <span>{{ blockedBy }}</span>
    </div>
  </div>
</template>
